import { api } from './api';
import { Case, CaseStatus } from '../types';

export interface CreateCaseRequest {
  clientId: string;
  childFirstName: string;
  childLastName: string;
  childDOB?: string;
  schoolDistrict?: string;
  school?: string;
  grade?: string;
  disabilities?: string[];
  services?: string[];
  notes?: string;
  status?: CaseStatus;
}

export interface UpdateCaseRequest extends Partial<Omit<CreateCaseRequest, 'clientId'>> {}

export const casesApi = {
  list: async (clientId?: string, status?: CaseStatus): Promise<{ cases: Case[]; count: number }> => {
    const params = new URLSearchParams();
    if (clientId) params.append('clientId', clientId);
    if (status) params.append('status', status);
    const queryString = params.toString();
    return api.get<{ cases: Case[]; count: number }>(`/cases${queryString ? `?${queryString}` : ''}`);
  },

  get: async (id: string): Promise<Case> => {
    return api.get<Case>(`/cases/${id}`);
  },

  create: async (data: CreateCaseRequest): Promise<Case> => {
    return api.post<Case>('/cases', data);
  },

  update: async (id: string, data: UpdateCaseRequest): Promise<Case> => {
    return api.put<Case>(`/cases/${id}`, data);
  },
};
